import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const ensembleTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      text: {
        primary: theme.color.text.core['-primary'],
      },
    },
  ]),
);
